// Define the active promotions
export const PROMOTIONS = {
    MARCH_2025_SALE: {
      name: "March 2025 Sale",
      description: "Limited Time Offer: 50% Off All Plans Until Cancelled",
      discountType: "percentage",
      discountValue: 50,
      startDate: new Date("2025-03-01T00:00:00Z"),
      endDate: new Date("2025-04-01T00:00:00Z"), 
      appliesTo: ["annual_plan", "monthly_plan"]
    }
  };
  
  // Check if a promotion is currently active
  export const isPromotionActive = (promotion) => {
    const now = new Date();
    return now >= promotion.startDate && now < promotion.endDate;
  };
  
  // Get the currently active promotion if any
  export const getActivePromotion = () => {
    // Check if we're in the March 2025 promotion period
    if (isPromotionActive(PROMOTIONS.MARCH_2025_SALE)) {
      console.log("March 2025 promotion is active!");
      return PROMOTIONS.MARCH_2025_SALE;
    }
    
    // For testing, you can force the promotion to be active by uncommenting:
    // return PROMOTIONS.MARCH_2025_SALE;
    
    return null;
  };